export default __webpack_public_path__ + "static/img7-362f6d5792b6745f6e308f66cd083715.png";